
  import { Vue } from "vue-class-component";
  export default class AppMain extends Vue {
  }
